import i18next from 'i18next';

export const getLocalizedParameterCategory = (categoryName) => {
    return i18next.t(`parameterCategories.${categoryName}`);
};
